import { HistoricalPerformanceToggleOptions, HistoricalPerformanceMetrics } from '@pff-consumer/schema'
import type { PlayerProfilesState } from '../player-profile-types'

export const getSelectedMetric = (state: PlayerProfilesState) => {
  return state.historicalPerformance.selectedToggle === HistoricalPerformanceToggleOptions.AvgL5
    ? HistoricalPerformanceMetrics.PAST_PERFORMANCE
    : HistoricalPerformanceMetrics.SIMILAR_DEFENSE
}
